module.exports = __webpack_public_path__ + "img/SEJ_Eventos_agregar pregunta.b2c27fc7.svg";